import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { fetchWhat3words, fetchWhat3wordsLocation } from './what3wordsAPI';

export const getWhat3Words = createAsyncThunk(
  'what3words/getWhat3Words',
  async ({ lat, lng, incidentType, id }, { rejectWithValue }) => {
    try {
      const response = await fetchWhat3words(parseFloat(lat), parseFloat(lng));
      return { words: response.words, incidentType, id, key: `${lat}_${lng}` };
    } catch {
      return rejectWithValue({ incidentType, id });
    }
  },
);

export const getWhat3WordsLocation = createAsyncThunk(
  'what3words/getWhat3WordsLocation',
  async (w3w, { rejectWithValue }) => {
    try {
      const response = await fetchWhat3wordsLocation(w3w);

      return response;
    } catch (error) {
      const { url, status, statusText, ok } = error;
      return await rejectWithValue({ url, status, statusText, ok });
    }
  },
);

const initialState = {
  calls: {},
  alerts: {},
  searched: {},
  error: null,
};

const what3wordsSlice = createSlice({
  name: 'what3words',
  initialState: initialState,
  reducers: {
    resetWhat3WordsLocation: state => {
      state.searched = initialState.searched;
    },
    resetWhat3WordsLocationError: state => {
      state.error = null;
    },
  },
  extraReducers: {
    [getWhat3Words.pending]: (state, action) => {
      const incidentType = action.meta.arg.incidentType;
      const id = action.meta.arg.id;
      const key = `${action.meta.arg.lat}_${action.meta.arg.lng}`;

      if (!state[incidentType][id]) {
        state[incidentType][id] = {
          [key]: { words: '', isLoading: true },
        };
      } else {
        state[incidentType][id][key] = { words: '', isLoading: true };
      }
    },
    [getWhat3Words.fulfilled]: (state, action) => {
      const { words, id, key, incidentType } = action.payload;

      state[incidentType][id][key] = {
        words,
        isLoading: false,
      };
    },
    [getWhat3Words.rejected]: (state, action) => {
      state[action.payload.incidentType][action.payload.id][
        action.payload.key
      ].isLoading = false;
    },
    [getWhat3WordsLocation.fulfilled]: (state, action) => {
      state.searched = { ...action.payload };
      state.error = null;
    },
    [getWhat3WordsLocation.rejected]: (state, action) => {
      state.error = action.payload;
    },
    ['emergencyCalls/removeCall']: (state, action) => {
      delete state.calls[action.payload];
    },
    ['emergencyCalls/removeAllCalls']: state => {
      state.calls = {};
    },
    ['incidents/removeAlert']: (state, action) => {
      delete state.alerts[action.payload];
    },
    ['FORCED_LOGOUT_SUCCESS']: () => {
      return initialState;
    },
    ['LOGOUT_SUCCESS']: () => {
      return initialState;
    },
    ['SINATRA_LOGOUT']: () => {
      return initialState;
    },
  },
});

export const {
  resetWhat3WordsLocation,
  resetWhat3WordsLocationError,
} = what3wordsSlice.actions;

const persistConfig = {
  key: 'what3words',
  storage,
  blacklist: ['error'],
};
const persistedReducer = persistReducer(persistConfig, what3wordsSlice.reducer);

export default persistedReducer;
